import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box } from '@chakra-ui/react';
import { Field } from 'formik';
import { useCompanyForm } from '../../hooks/useCompanyForm';
import NameField from '@/components/forms/new/formikFormFields/NameField';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { FORM_FIELD_PATHS } from '../../constants';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
} from 'components/forms/new/formStyles';

const PrimaryContactPhone = ({ darkMode, errors, touched }) => {
    const [isHovered, setIsHovered] = useState(false);
    const { formData, updateFormData } = useCompanyForm();

    const handleChange = (e) => {
        updateFormData(FORM_FIELD_PATHS.PRIMARY_CONTACT_PHONE, e.target.value);
    };

    const validatePhone = (value) => {
        if (!value) return undefined;

        // Remove all non-digit characters for validation
        const digits = value.replace(/\D/g, '');

        // Check if it's a valid phone number (7-15 digits)
        if (digits.length < 7 || digits.length > 15) {
            return 'Phone number must be between 7 and 15 digits';
        }

        // Basic phone number pattern validation
        const phoneRegex =
            /^[+]?[1-9][\d]{0,3}[-.\s]?[(]?[\d]{1,4}[)]?[-.\s]?[\d]{1,4}[-.\s]?[\d]{1,9}$/;
        if (!phoneRegex.test(value)) {
            return 'Please enter a valid phone number';
        }
    };

    const hasError =
        !!errors?.primaryContactPhone && touched?.primaryContactPhone;

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={hasError}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()}>
                <FormLabel sx={formLabelStyling(darkMode)}>
                    Primary Contact Phone
                </FormLabel>
                <Box flex={1} maxWidth="400px">
                    <Field
                        component={NameField}
                        id="primaryContactPhone"
                        name="primaryContactPhone"
                        type="tel"
                        value={formData?.primaryContactPhone || ''}
                        onChange={handleChange}
                        placeholder="Enter primary contact phone"
                        width="100%"
                        darkMode={darkMode}
                        isInvalid={hasError}
                        validate={validatePhone}
                    />
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Enter the phone number of the primary contact"
                        ariaLabel="primary-contact-phone-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default PrimaryContactPhone;
